import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { checkIfAuthenticated, decodeJwt } from '../utils/Authentication';

function PrivateRoute({ role }) {
  const isAuthenticated = checkIfAuthenticated(role);
  let location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to='/' state={{ from: location }} />;
  }

  return <Outlet />;
}

export default PrivateRoute;
